import '../../core/components/app-root/AppRoot.css';
import './SimpleTable.css';
export var simpleTable = '_1ymahou0-3-8-0';